
import { Vue } from "vue-class-component";

export default class Route extends Vue {}
